import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

// Datepicker
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import subDays from "date-fns/subDays"
import format from 'date-fns/format'
import { de } from 'date-fns/locale/de';

// Semantic UI
import { Button, Form, FormCheckbox, FormInput, Icon, Label, Table } from 'semantic-ui-react';

// Actions
import { setContractData, doContractAction } from "./contractSlice";

// Styles
import './contract.css';


//
registerLocale('de', de);
setDefaultLocale('de');



/**
 * 
 * @param {bool} editMode
 * @param {bool} additional
 * @returns 
 */
const Max2ContractHeadOfficeRelease = ({ editMode, additional }) => {
  // global State
  const dispatch = useDispatch();
  const Contract = useSelector((state) => state.contract.data.Contract);
  const Release = additional ? Contract.ReleaseUS : Contract.Release;

  const { t } = useTranslation();

  // Edit mode?
  const readOnly = editMode ? false : true;
  
  

  /**
   * only numbers allowed in allotment max input
   * @param {event} e 
   */
  const handleKeyPress = (e) => {
    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };



  /**
   * 
   */
  const handleDeleteRow = (rowIndex) => {
    dispatch(doContractAction({target: 'Release.deleteRow', value: rowIndex}))
  }



  /**
   * 
   */
  const handleCopyRow = (rowIndex) => {
    dispatch(doContractAction({target: 'Release.copyRow', value: rowIndex}))
  }



  /**
   * 
   * @param {bool} headoffice 
   */
  const handleAddNewRow = (headoffice = false) => {
    dispatch(doContractAction({target: 'Release.addRow', value: headoffice}))
  }

  // If no records
  if (typeof Release === 'undefined' || !Release || !Release.length) {
    return (
      <> 
      {!readOnly && (
        <>
        <Button basic circular icon labelPosition='left' onClick={() => handleAddNewRow()}>
          <Icon name='plus' />
          {t('contract.headoffice.actions.addRow')}
        </Button>
        <Button basic circular icon labelPosition='left' onClick={() => handleAddNewRow(true)}>
          <Icon name='plus' />
          {t('contract.headoffice.actions.addRowHeadOffice')}
        </Button>
        </>
      )}
      </>
    );
  }

  return (
    <>
    <Table celled structured striped basic='very'>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell></Table.HeaderCell>
          <Table.HeaderCell>{t('contract.headoffice.table.from')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.headoffice.table.to')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.seasons.weekdays.monShort')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.seasons.weekdays.tueShort')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.seasons.weekdays.wedShort')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.seasons.weekdays.thuShort')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.seasons.weekdays.friShort')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.seasons.weekdays.satShort')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.seasons.weekdays.sunShort')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.headoffice.table.days')}</Table.HeaderCell>
          {!readOnly && (
            <Table.HeaderCell></Table.HeaderCell>
          )}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {Release.map((release, releaseKey)=>(
          <Table.Row key={releaseKey}>
            <Table.Cell>
              {!release.Additional && (<Label as='a' color='red' ribbon>{t('settings.userDetails.headOffice')}</Label>)}
            </Table.Cell>
            <Table.Cell>
              {readOnly ? (
                <span>{format(release.Start, "dd.MM.yyyy")}</span>
              ) : (
                <DatePicker
                  showWeekNumbers
                  selectsStart
                  readOnly={readOnly}
                  selected={release.Start}
                  startDate={release.Start}
                  endDate={release.End}
                  dateFormat="dd.MM.yyyy"
                  placeholder={t('contract.specials.modal.datePlaceholder')}
                  excludeDateIntervals={[
                    { start: new Date("1970-01-01"), end: subDays(new Date(Contract.Period.Start), 1) },
                    { start: new Date(Contract.Period.End), end: new Date("9999-12-31") },
                  ]}
                  onChange={(date) => dispatch(setContractData({target: 'Release.Start', row: releaseKey,  value: format(date, "yyyy-MM-dd")}))}
                  customInput={<FormInput inline icon='calendar alternate' iconPosition='left' placeholder={t('contract.specials.modal.datePlaceholder')} style={{width: "130px"}} />}
                />
              )}
            </Table.Cell>
            <Table.Cell>
              {readOnly ? (
                <span>{format(release.Start, "dd.MM.yyyy")}</span>
              ) : (
                <DatePicker
                  showWeekNumbers
                  selectsEnd
                  readOnly={readOnly}
                  selected={release.End}
                  startDate={release.Start}
                  endDate={release.End}
                  minDate={release.Start}
                  dateFormat="dd.MM.yyyy"
                  placeholder='TT.MM.JJJJ'
                  excludeDateIntervals={[
                    { start: new Date("1970-01-01"), end: subDays(new Date(release.Start), 1) },
                    { start: new Date(Contract.Period.End), end: new Date("9999-12-31") },
                  ]}
                  onChange={(date) => dispatch(setContractData({target: 'Release.End', row: releaseKey,  value: format(date, "yyyy-MM-dd")}))}
                  customInput={<FormInput inline icon='calendar alternate' iconPosition='left' placeholder='TT.MM.JJJJ' style={{width: "130px"}} />}
                />
              )}
            </Table.Cell>
            <Table.Cell>{readOnly ? <>{release.Weekdays.mon ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={release.Weekdays.mon ? true : false} onClick={() => dispatch(setContractData({target: 'Release.Weekday', row: releaseKey,  weekday: 'mon', value: !release.Weekdays.mon }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{release.Weekdays.tue ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={release.Weekdays.tue ? true : false} onClick={() => dispatch(setContractData({target: 'Release.Weekday', row: releaseKey,  weekday: 'tue', value: !release.Weekdays.tue }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{release.Weekdays.wed ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={release.Weekdays.wed ? true : false} onClick={() => dispatch(setContractData({target: 'Release.Weekday', row: releaseKey,  weekday: 'wed', value: !release.Weekdays.wed }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{release.Weekdays.thu ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={release.Weekdays.thu ? true : false} onClick={() => dispatch(setContractData({target: 'Release.Weekday', row: releaseKey,  weekday: 'thu', value: !release.Weekdays.thu }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{release.Weekdays.fri ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={release.Weekdays.fri ? true : false} onClick={() => dispatch(setContractData({target: 'Release.Weekday', row: releaseKey,  weekday: 'fri', value: !release.Weekdays.fri }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{release.Weekdays.sat ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={release.Weekdays.sat ? true : false} onClick={() => dispatch(setContractData({target: 'Release.Weekday', row: releaseKey,  weekday: 'sat', value: !release.Weekdays.sat }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{release.Weekdays.sun ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={release.Weekdays.sun ? true : false} onClick={() => dispatch(setContractData({target: 'Release.Weekday', row: releaseKey,  weekday: 'sun', value: !release.Weekdays.sun }))} />}</Table.Cell>
            <Table.Cell>
            {readOnly ? <>{release.Value}</> : <Form><FormInput type="number" maxLength={2} onKeyPress={handleKeyPress} style={{width: "70px"}} value={release.Value} onChange={(e, data) => dispatch(setContractData({target: 'Release.Value', row: releaseKey,  value: data.value}))} /></Form>}
            </Table.Cell>
            {!readOnly && (
              <Table.Cell>
                <Button basic circular icon>
                  <Icon name='trash' onClick={() => handleDeleteRow(releaseKey)} />
                </Button>
                <Button basic circular icon>
                  <Icon name='copy outline' onClick={() => handleCopyRow(releaseKey)} />
                </Button>
              </Table.Cell>
            )}
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
    {!readOnly && (
      <>
      <Button basic circular icon labelPosition='left' onClick={() => handleAddNewRow()}>
        <Icon name='plus' />
        {t('contract.headoffice.actions.addRow')}
      </Button>
      <Button basic circular icon labelPosition='left' onClick={() => handleAddNewRow(true)}>
        <Icon name='plus' />
        {t('contract.headoffice.actions.addRowHeadOffice')}
      </Button>
      </>
    )}
    </>
  );
}

export default Max2ContractHeadOfficeRelease;
